import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { AsyncPipe, NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ActionItem } from '../../../../elements/components/action-item/entities/action-item.entity';
import { DropdownDirection } from '../../../entities/dropdown-direction.entity';
import { MultiFormSelectOptions } from '../../../entities/multi-form-select-options.entity';
import { MultiFormSelectStyle } from '../../../entities/multi-form-select-style.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';
import { ShFormMultiSelectComplexBaseComponent } from '../base-complex/form-multi-select-complex-base.component';
import { ShFormMultiSelectBaseComponent } from '../base-simple/form-multi-select-base.component';

@Component({
    selector: 'sh-form-multi-select',
    templateUrl: './form-multi-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ShFormGroupComponent,
    ShFormMultiSelectComplexBaseComponent,
    ReactiveFormsModule,
    NgClass,
    ShFormMultiSelectBaseComponent,
    AsyncPipe
]
})
export class ShFormMultiSelectComponent<T = string> extends ShBaseFormComponent implements OnInit, OnDestroy {
    @Input() options: MultiFormSelectOptions<T> = { options: [], isLiveData: false };

    @Input() isLoading = false;

    @Input() multiple = false;
    @Input() unwrapList: boolean = false; // Only when !multiple && !indeterminate
    @Input() search = false;
    @Input() height = 300;
    @Input() openDirection?: DropdownDirection = DropdownDirection.Below;
    @Input() style?: MultiFormSelectStyle = MultiFormSelectStyle.Default;
    @Input() wrapLabel = false;
    @Input() inOverflownContainer = false;
    @Input() itemCapCount = 50;
    @Input() limitHeightToViewport = false;
    @Input() noResultsActionItem?: ActionItem;
    @Input() sortAlphabetically = false;
    @Input() allowSingleDeselect = true;

    @Input() autocomplete = false;
    @Input() autocompleteFct?: (term: string) => Observable<string[]>;

    // Messages
    @Input() noResultsFoundMsg: string = this.translateService.translate('ui.no-results');
    @Input() loadingMsg = this.translateService.translate('ui.loading');
    @Input() searchPlaceholderMsg: string = this.translateService.translate('ui.search');
    @Input() multipleSelectedMsg!: string;
    @Input() allSelectedMsg = '';
    @Input() noneSelectedMsg = '';
    @Input() placeholderMsg?: string;
    @Input() prefixMsg = '';
    @Input() listCappedMsg = this.translateService.translate('ui.capped-results');

    @Output() searchTerm: EventEmitter<string> = new EventEmitter<string>();
    @Output() shownItemCount: EventEmitter<number> = new EventEmitter<number>();

    onSearchTermChange(searchTerm: string): void {
        this.searchTerm.emit(searchTerm);
    }

    onShownItemCountChange(shownItemCount: number): void {
        this.shownItemCount.emit(shownItemCount);
    }
}
